import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import { getFormattedPrice } from '../../helpers/price';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  defaultValues?: any;
}

export default function Form33(props: Props) {
  const { control, handleSubmit, errors, watch } = useForm({
    defaultValues: replaceDefaultValues(
      {
        pricesProperty: '',
        pricesPenaltyFee: '',
        pricesSeparationPayment: '',
      },
      props.defaultValues
    ),
  });

  const watchPricesProperty = watch('pricesProperty');
  const penaltyFeeMax = (Number(watchPricesProperty) || 0) * 0.1;
  const separationPaymentMax = (Number(watchPricesProperty) || 0) * 0.3;

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Valores</h1>

      <FormElement
        name="pricesProperty"
        label="Valor de la propiedad*"
        elementType="price"
        control={control}
        rules={{ required: true }}
        error={errors.pricesProperty}
      />

      <FormElement
        name="pricesSeparationPayment"
        label="Valor a pagar a la firma de la promesa*"
        subLabel={
          <>
            El resto será pagado al momento de la firma de la escritura pública.
            <br />
            Valor máximo de {getFormattedPrice(separationPaymentMax)}
          </>
        }
        elementType="price"
        control={control}
        rules={{ required: true, max: separationPaymentMax }}
        error={errors.pricesSeparationPayment && 'Valor incorrecto.'}
      />

      <FormElement
        name="pricesPenaltyFee"
        label="Valor cláusula penal*"
        subLabel={<>Valor máximo de {getFormattedPrice(penaltyFeeMax)}</>}
        elementType="price"
        control={control}
        rules={{ required: true, min: 0, max: penaltyFeeMax }}
        error={errors.pricesPenaltyFee && 'Valor incorrecto.'}
      />

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
